import React from "react";
import styled from "styled-components";
import { CTAButton, CTAButtonWrapper } from "./HeroSection";

const WhyChooseUs = ({ openModal }) => {
  return (
    <Wrapper>
      <Content>
        <SmallTitle>Why Choose Us!</SmallTitle>
        <MainTitle>
          Top Reasons Why People <span>Choose Us</span>!
        </MainTitle>
        <Description>
          We provide expert solutions, a dedicated team, and unwavering support
          for your success. Here’s what sets us apart.
        </Description>
        <CTAButtonWrapper>
          <CTAButton onClick={openModal}>Book a Free call now</CTAButton>
        </CTAButtonWrapper>
      </Content>

      <Cards>
        <Card>
          <Icon className="fa-solid fa-handshake"></Icon>
          <CardTitle>Trusted Partnership</CardTitle>
          <CardText>
            We build long-lasting relationships based on trust, transparency,
            and results.
          </CardText>
        </Card>

        <Card>
          <Icon className="fa-solid fa-user-shield"></Icon>
          <CardTitle>Expert Guidance</CardTitle>
          <CardText>
            Reliable financial insights to help you make informed decisions.
          </CardText>
        </Card>

        <Card>
          <Icon className="fa-solid fa-clock"></Icon>
          <CardTitle>Timely Support</CardTitle>
          <CardText>
            Count on us for prompt assistance and quick resolution of your
            concerns.
          </CardText>
        </Card>

        <Card>
          <Icon className="fa-solid fa-award"></Icon>
          <CardTitle>Proven Excellence</CardTitle>
          <CardText>
            Focused on delivering quality service you can count on.
          </CardText>
        </Card>
      </Cards>
    </Wrapper>
  );
};

export default WhyChooseUs;

// Styled Components

const Wrapper = styled.section`
  max-width: 1200px;
  margin: 80px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  span {
    color: #fdc500;
  }
`;

const Content = styled.div`
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
`;

const SmallTitle = styled.h6`
  color: #005f73;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-size: 1rem;
  letter-spacing: 1px;
`;

const MainTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #005f73;
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 40px;
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
`;

export const Card = styled.div`
  background: #ffffff;
  padding: 30px 20px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
    background: #005f73;
    color: #fff;

    i {
      color: #fff;
    }
  }
`;

export const Icon = styled.i`
  font-size: 2.5rem;
  color: #005f73;
  margin-bottom: 20px;
  transition: color 0.3s ease;
`;

export const CardTitle = styled.h5`
  font-size: 1.25rem;
  margin-bottom: 15px;
`;

export const CardText = styled.p`
  margin: auto;
  font-size: 1.1rem;
  line-height: 1.5;
`;
